import { useMobile } from "@lib/hooks/useMobile";
import { StyledDownloadButton } from "./DownloadButton.styles";

import { getLanguage } from "@/lib/config";
import DownloadIconDesktopSVG from './assets/download-icon-desktop.svg';
import DownloadIconMobileSVG from './assets/download-icon-mobile.svg';

export interface DownloadButtonProps {
  fileName: string;
  fileType: string;
  fileSize: string;
  url: string;
  target?: string | null;
}
export default function DownloadButton(data: DownloadButtonProps) {
  const isMobile = useMobile();
  const language = getLanguage();
  return (
    <StyledDownloadButton
      {...data}
      href={data.url}
      target={data.target !== null ? data.target : ""}
      download>
      <div className="download__icon">
        {isMobile ? (
          <DownloadIconMobileSVG />
        ) : (
          <DownloadIconDesktopSVG />
        )}
      </div>
      <div className="download__text">
        <span className="download__title" lang={language !== 'en' ? language : undefined}>{data.fileName}</span>
        <div className="download__info">
          {(data.fileType && data.fileType.length > 0)
            && `${data.fileType}, `
          }
          {data.fileSize}
        </div>
      </div>
    </StyledDownloadButton>
  );
}
